import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function PageLayout({ title, subtitle, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />
      <div className="pt-[142px] flex-1">
        <section className="border-b border-[#d7e5e9] py-12 md:py-16 text-center px-5">
          <h1 className="font-serif-display text-[#68c2d5] text-4xl md:text-[3.2rem] leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="font-serif-body text-[#555] text-[15px] md:text-[17px] mt-4 max-w-2xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}
        </section>
        <main>{children}</main>
      </div>
      <Footer />
    </div>
  );
}
